import "./UserProfile.scss";
import {
  Row,
  Col,
  Tabs,
  Label,
  InputField,
  DropdownBox,
  DialogBox,
  PrimaryButton,
  SwitchToggle
} from "../../CommonComponents";
import { MaskedTextField } from "@fluentui/react";
import CancelConfirmationPopup from "client/CommonComponents/DialogBox/CancelConfirmationPopup";
import { CONSTANTS } from "client/utils/constants";
import { useLocation } from "react-router-dom";
import { ASSET_INVENTORY_CONSTANTS } from "client/utils/constants/assetInventory";
import OOOTab from "./OOOTab";

interface IProps {
  userName?: any;
  onChangeProfile?: any;
  file?: any;
  multiple?: boolean;
  countryDropdown?: any;
  formError?: any;
  onSubmitForm?: any;
  onUpdateProfileField?: any;
  form?: any;
  BranchDetails?: any;
  titleDetails?: any;
  departmentDetails?: any;
  selectedCountry?: any;
  onChangeCountry?: any;
  OnCheckboxClick?: any;
  checkedValue?: any;
  closeModalPopup?: any;
  hideConfirmationDialog?: any;
  isConfirmationDialogVisible?: any;
  confirmationDialogContentProps?: any;
  resultMessage?: any;
  userprofileinfo?: any;
  uploadedImage?: string;
  userDetails?: any;
  alertConfiguration?: any;
  branchTabContent?: any;
  profileImage?: any;
  onClick?: any;
  getResultMessage?: any;
  notificationConfiguration?: any;
  errorMessage?: any;
  selectedTab: any,
  handleLinkClick?: any,
  hideApprovalConfirmationDialog?: any,
  Popupcontent?: any,
}

const UserProfile = ({
  userName,
  onChangeProfile,
  file,
  countryDropdown,
  onSubmitForm,
  formError,
  form,
  onUpdateProfileField,
  selectedCountry,
  onChangeCountry,
  hideConfirmationDialog,
  isConfirmationDialogVisible,
  confirmationDialogContentProps,
  userprofileinfo,
  userDetails,
  alertConfiguration,
  branchTabContent,
  profileImage,
  getResultMessage,
  notificationConfiguration,
  errorMessage,
  selectedTab,
  handleLinkClick,
  hideApprovalConfirmationDialog,
  Popupcontent,
  closeModalPopup
}: IProps) => {

  const path = useLocation();
  const pathName = path?.pathname?.split("/")[1];


  const profileTabContent = () => {
    return (
      <div className="profile-tab-ui">
        {/* <p className="profile">PROFILE</p> */}
        <Row>
          <Col xs={4} md={2} lg={2} className="fileupload-userprofile mb-3">
            <div className="file-upload-wrapper">
              <button className="choose-file" data-attribute="UserProfile_Default_Button">
                <img
                  height={40}
                  width={40}
                  src={profileImage()}
                  title="file-upload"
                  alt={userprofileinfo.imagename}
                  className={
                    !userprofileinfo.imguploaded
                      ? "img-nonactive"
                      : "img-active"
                  }
                />
              </button>
              {userprofileinfo.imguploaded ? (
                <span className="nofile-chosen">No file chosen</span>
              ) : (
                <span className="file-name">{file}</span>
              )}
              <input
                type="file"
                name="myfile"
                className="file-upload"
                onChange={onChangeProfile}
                accept="image/png, image/jpeg"
               data-attribute="UserProfile_myfile_Input" />
            </div>
          </Col>

          <Col xs={8} md={10} lg={10} className="mb-1">
            <div className="profile-requirement">
              Supported format PNG, JPG, / Dimensions Max 400x400 / Size Max
              150kb.
            </div>
            <span className="validation-errorMsg">
              {userprofileinfo.profileImageError}
            </span>
          </Col>
          <Col xs={12} className="mb-2">
            <div className="listItem">
              <label className="label labelText">Role:</label>
              {pathName?.toLowerCase() === ASSET_INVENTORY_CONSTANTS.ASSET_INVENTORY_PATHNAME ?
                <div className="label userRole">
                  {userDetails?.roles?.reduce((acc: any[], x: any) => {
                    if (x?.applicationName === CONSTANTS?.ASSET_AUDIT_INVENTORY_MANAGEMENT) {
                      return acc.concat(x?.roleDisplayName)
                    }
                    return acc
                  }, [])?.join(", ")}
                </div> :
                <div className="label userRole">
                  {userDetails?.roles?.reduce((acc: any[], x: any) => {
                    if (x?.applicationName === CONSTANTS?.ORDER_MANAGEMENT) {
                      return acc.concat(x?.roleDisplayName)
                    }
                    return acc
                  }, [])?.join(", ")}
                </div>}
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={6} className="mb-3">
            <Label data-attribute="UserProfile_Default_Label">First Name</Label>
            <InputField name="firstName" value={userName?.firstName} readOnly  data-attribute="UserProfile_firstName_Input" />
          </Col>
          <Col lg={6} className="mb-3">
            <Label data-attribute="UserProfile_Default_Label_2">Last Name</Label>
            <InputField name="lastName" value={userName?.lastName} readOnly  data-attribute="UserProfile_lastName_Input" />
          </Col>
          <Col lg={6} className="mb-3">
            <Label data-attribute="UserProfile_Default_Label_3">Preferred Name</Label>
            <InputField
              name="userName"
              value={form?.userName}
              onChange={onUpdateProfileField}
             data-attribute="UserProfile_userName_Input" />
          </Col>
          <Col lg={6} className="mb-3">
            <Label required data-attribute="UserProfile_Default_Label_4">Email Address</Label>
            <InputField name="userEmail" value={userName?.userEmail} readOnly  data-attribute="UserProfile_userEmail_Input" />
          </Col>
          <Col lg={6} className="mb-3">
            <Label required data-attribute="UserProfile_Default_Label_5">Title</Label>
            <InputField name="title" value={userName?.title} readOnly  data-attribute="UserProfile_title_Input" />
          </Col>
          <Col lg={6} className="mb-3">
            <Label required data-attribute="UserProfile_Default_Label_6">Employee Number</Label>
            <InputField
              name="employeeNumber"
              value={userName?.employeeNumber}
              readOnly
             data-attribute="UserProfile_employeeNumber_Input" />
          </Col>
          <Col lg={6} className="mb-3">
            <Label required data-attribute="UserProfile_Default_Label_7">Home Cost Center</Label>
            <InputField
              name="homeCostCenter"
              value={userName?.homeCostCenter}
              readOnly
             data-attribute="UserProfile_homeCostCenter_Input" />
          </Col>
        </Row>
        <p className="mb-2 driver-Info">User Information</p>
        <Row>
          <Col lg={6} className="mb-3">
            <Label data-attribute="UserProfile_Default_Label_8">Personal Email Address</Label>
            <InputField
              placeholder="Personal Email Id"
              name="personalEmailId"
              value={form.personalEmailId}
              onChange={onUpdateProfileField}
             data-attribute="UserProfile_personalEmailId_Input" />
            {formError?.emailId ? (
              <span className="asset-validation-msg">{formError.emailId}</span>
            ) : null}
          </Col>
          <Col lg={6} className="mb-3">
            <Label data-attribute="UserProfile_Default_Label_9">Contact #</Label>
            <MaskedTextField
              placeholder="Contact"
              className="form-input"
              mask="(999) 999-9999"
              name="contactNo"
              value={form.contactNo || undefined}
              onChange={onUpdateProfileField}
            />
            {formError?.contactNoError ? (
              <span className="asset-validation-msg">
                {formError.contactNoError}
              </span>
            ) : null}
          </Col>
          <Col lg={6} className="mb-3">
            <Label data-attribute="UserProfile_Default_Label_10">Address</Label>
            <InputField
              placeholder="Address Line 1"
              name="addressLine1"
              value={form.addressLine1}
              onChange={onUpdateProfileField}
             data-attribute="UserProfile_addressLine1_Input" />
            {formError?.addressLine1Error ? (
              <span className="asset-validation-msg">
                {formError.addressLine1Error}
              </span>
            ) : null}
          </Col>
          <Col lg={6} className="mb-3 mt-lg-3">
            <InputField
              className="mt-lg-3"
              placeholder="Address Line 2"
              name="addressLine2"
              value={form.addressLine2}
              onChange={onUpdateProfileField}
             data-attribute="UserProfile_addressLine2_Input" />
            {formError?.addressLine2Error ? (
              <span className="asset-validation-msg">
                {formError.addressLine2Error}
              </span>
            ) : null}
          </Col>
          <Col lg={6} className="mb-3">
            <InputField
              placeholder="City"
              name="city"
              value={form.city}
              onChange={onUpdateProfileField}
             data-attribute="UserProfile_city_Input" />
            {formError?.cityError ? (
              <span className="asset-validation-msg">
                {formError.cityError}
              </span>
            ) : null}
          </Col>
          <Col lg={6} className="mb-3">
            <InputField
              placeholder="State/Region"
              name="state"
              value={form.state}
              onChange={onUpdateProfileField}
             data-attribute="UserProfile_state_Input" />
            {formError?.stateError ? (
              <span className="asset-validation-msg">
                {formError.stateError}
              </span>
            ) : null}
          </Col>
          <Col lg={6} className="mb-3">
            <InputField
              placeholder="ZIP/Postal Code"
              name="zipCode"
              value={form.zipCode}
              onChange={onUpdateProfileField}
             data-attribute="UserProfile_zipCode_Input" />
            {formError?.zipCodeError ? (
              <span className="asset-validation-msg">
                {formError.zipCodeError}
              </span>
            ) : null}
          </Col>
          <Col lg={6} className="mb-3">
            <DropdownBox
              placeholder="Select"
              options={countryDropdown}
              name="countryId"
              value={
                selectedCountry
                  ? selectedCountry
                  : { key: null, text: "Select" }
              }
              selectedKey={selectedCountry ? selectedCountry.key : null}
              onChange={onChangeCountry}
             data-attribute="UserProfile_countryId_Dropdown" />
          </Col>
          <Col lg={6} className="mb-3 hidden-field">
            <InputField
              type="hidden"
              name="User_id"
              value={form.id}
              className="hidden"
             data-attribute="UserProfile_User_id_Input" />
          </Col>
          <p className="privacy-info mb-3">
            <b>Privacy Note : </b> This information is confidential and will not
            be shared or used for reporting purpose. This information will used
            for vehicle information or insurance.
          </p>
        </Row>
      </div>
    );
  };

  const alertNotificationTabContent = () => {
    return (
      <div className='alert-notification-ui'>
        <div className="alert-switch mb-3">
          <p className="driver-Info mb-1">Alert</p>
          {alertConfiguration.map((item: any, index: any) => {
            return (
              <div className="switch-section" key={index}>
                <Label data-attribute="UserProfile_Default_Label_11">{item.text}</Label>
                <SwitchToggle
                  checked={item.checked}
                  onChange={item.onChange}
                 data-attribute="UserProfile_Default_SwitchToggle" />
              </div>
            );
          })}
        </div>
        <div className="alert-switch">
          <p className="driver-Info mb-1">Notification</p>
          {notificationConfiguration.map((item: any, index: any) => {
            return (
              <div className="switch-section" key={index}>
                <Label data-attribute="UserProfile_Default_Label_12">{item.text}</Label>
                <SwitchToggle
                  checked={item.checked}
                  onChange={item.onChange}
                 data-attribute="UserProfile_Default_SwitchToggle_2" />
              </div>
            );
          })}
        </div>
      </div>
    )
  }

  const iconItems = [
    {
      headerText: "Personal Info",
      content: profileTabContent(),
    },
    {
      headerText: "Alerts",
      content: alertNotificationTabContent(),
    },
    {
      headerText: "Locations",
      content: branchTabContent(),
    },
    {
      headerText: "Out of Office",
      content: <OOOTab closeModalPopup={closeModalPopup}/>,
    }
  ];

  return (
    <div className="user-profile-container">
      {isConfirmationDialogVisible && getResultMessage !== "" && (
        <DialogBox
          dialogContentProps={confirmationDialogContentProps}
          hideDialog={!isConfirmationDialogVisible}
          onDismiss={hideConfirmationDialog}
         data-attribute="UserProfile_Default_DialogBox" />
      )}
     
      {
        Popupcontent.isDialogVisible && (
          <CancelConfirmationPopup
            hideDialog={!Popupcontent.isDialogVisible}
            onDismiss={hideApprovalConfirmationDialog}
            Popupcontent={Popupcontent}
            popupOutlinebtnOnclick={() => Popupcontent?.popupOutlinebtnOnclick()}
            popupPrimarybtnOnclick = {() => Popupcontent?.popupPrimarybtnOnclick()}
          />
        )
      }
      <Row>
        <Tabs
          tabItems={iconItems}
          linkFormat="links"
          className="userprofile-tab"
          handleLinkClick={handleLinkClick}
         data-attribute="UserProfile_Default_Tabs" />
      </Row>
      <div className="pull-right py-3">
        {formError?.branchError || formError?.zipCodeError || formError?.stateError || formError?.cityError ||
          formError?.addressLine2Error || formError?.addressLine1Error || formError?.contactNoError || formError?.emailId ? (
          <span className="errorMsg branch-errormsg">{errorMessage}</span>
        ) : null}
        {(!["Out of Office"].includes(selectedTab)) ?
          <PrimaryButton
            text="Save"
            className="pull-right"
            onClick={onSubmitForm}
           data-attribute="UserProfile_Default_Button_2" /> : null
        }
      </div>
    </div>
  );
};

export default UserProfile;
